import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref, watch, withDefaults } from 'vue'
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'


export default /*#__PURE__*/_defineComponent({
  __name: 'TextEditor',
  props: {
    content: { default: () => null },
    returnOn: { default: () => 'input' }
  },
  emits: ['contentChange'],
  setup(__props: any, { emit }) {

const props = __props as { content: string|null, returnOn:string };

const editor = ClassicEditor
const editorConfig = {
  toolbar: [
    'bold', 'italic', '|',
    'bulletedList', 'numberedList'
  ]
}

const editorData = ref<string|null>(null)



onMounted(() => {
  checkIfPropSet()
})

watch(() => props.content, () => {
  checkIfPropSet()
})

function checkIfPropSet () :void {
  if (props.content) {
    editorData.value = props.content
  } else {
    editorData.value = ''
  }
}

function inputChanged (text:string) : void {
  if (props.returnOn === 'input') {
    emit('contentChange', text)
  }
}

function blurChanged (text:string) : void {
  if (props.returnOn === 'blur') {
    emit('contentChange', editorData.value)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(CKEditor).component), {
    editor: _unref(editor),
    config: editorConfig,
    modelValue: editorData.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((editorData).value = $event)),
    onInput: inputChanged,
    onBlur: blurChanged
  }, null, 40, ["editor", "modelValue"]))
}
}

})